/**
 * ProgressRing — circular progress indicator used in the resolution banner.
 * Ported from charts.jsx in the Claude Design output.
 */

interface ProgressRingProps {
  pct: number;
  size?: number;
  stroke?: number;
  color?: string;
  track?: string;
}

export function ProgressRing({
  pct,
  size = 56,
  stroke = 4,
  color = 'var(--accent-400)',
  track = 'rgba(255,255,255,0.12)',
}: ProgressRingProps) {
  const r = (size - stroke) / 2;
  const c = size / 2;
  const circ = 2 * Math.PI * r;
  const len = (pct / 100) * circ;
  return (
    <svg viewBox={`0 0 ${size} ${size}`} width={size} height={size}>
      <circle cx={c} cy={c} r={r} fill="none" stroke={track} strokeWidth={stroke} />
      <circle
        cx={c}
        cy={c}
        r={r}
        fill="none"
        stroke={color}
        strokeWidth={stroke}
        strokeDasharray={`${len} ${circ - len}`}
        transform={`rotate(-90 ${c} ${c})`}
        strokeLinecap="round"
      />
    </svg>
  );
}
